import React from "react";
import { css } from "glamor";
import clear from "@safecv/assets/Images/clear.png";

function ToastCloseButton({ closeToast, type, ariaLabel }) {
  const styles = css({
    left: "20.83%",
    right: "20.83%",
    top: "20.83%",
    bottom: "20.83%",
    color: "#000",
    fontWeight: "bold",
    fontSize: "18px",
    background: "transparent",
    outline: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    opacity: "0.7",
    transition: ".3s ease",
    alignSelf: "flex-start",
    ":hover, :focus": {
      opacity: 1
    }
  });
  return (
    <img src={clear} 
          {...styles}
          onClick={closeToast}
          aria-label={ariaLabel}
          alt="clear toast msg"></img>
  );
}

export default ToastCloseButton;
